import { useMemo } from 'react'

import { useFormContext, useWatch } from 'react-hook-form'

import { TransactionFormValues } from '~/components/smart-accounts/transactions/types'
import { BasicTransactionType } from '~/types'

/**
 * Hook to extract the transfer token from transaction form values
 * Handles Transfer and Swap, and Earn transactions types
 */
export const useTransactionFormTransferToken = (
  transactionTypes: BasicTransactionType[],
) => {
  const { control } = useFormContext<TransactionFormValues>()
  const formValues = useWatch({ control })

  const transferToken = useMemo(() => {
    if (transactionTypes.includes(BasicTransactionType.Transfer)) {
      // TransferFormValues fields
      if ('transferToken' in formValues && formValues.transferToken) {
        return formValues.transferToken
      }
    }

    if (transactionTypes.includes(BasicTransactionType.Swap)) {
      // TransferFormValues fields (autoswap)
      if ('swapData' in formValues && formValues.swapData?.sellToken) {
        return formValues.swapData.sellToken
      }

      // SwapFormValues fields
      if ('sourceToken' in formValues && formValues.sourceToken) {
        return formValues.sourceToken
      }
    }

    if (transactionTypes.includes(BasicTransactionType.Earn)) {
      if ('swapData' in formValues && formValues.swapData?.sellToken) {
        return formValues.swapData.sellToken
      }
    }

    return undefined
  }, [formValues, transactionTypes])

  return transferToken
}
